import { render } from "./myProxy.vue?vue&type=template&id=17963852&scoped=true"
import script from "./myProxy.vue?vue&type=script&lang=js"
export * from "./myProxy.vue?vue&type=script&lang=js"

import "./myProxy.vue?vue&type=style&index=0&id=17963852&lang=scss&scoped=true"
import "./myProxy.vue?vue&type=style&index=1&id=17963852&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17963852"]])

export default __exports__